// extracted by mini-css-extract-plugin
export var banner = "_qz-0";
export var settingRow = "_qz-2";
export var titleIcon = "_qz-1";